import React from 'react'
let PropTypes = React.PropTypes
import ReactNotify from 'react-notify'
import * as ReactNotifyCSS from '../../shared/ReactNotify/ReactNotify.css'
import BlackBoxInventarios from '../diferencias-inventarios/BlackBoxInventarios.js'
import api from '../../apiClient/v1'
import { TablaInventarios } from './TablaInventarios.jsx'
import {
    ModalTrigger,
    ModalDetalle,
    ModalFacturacion

} from './Modales.jsx'

export class InventariosFacturacion extends React.Component{
    constructor(props){
        super(props)
        this.blackbox = new BlackBoxInventarios()
        this.state = {
            mes: this.props.meses[0]['value'],
            inventariosFiltrados: [],
            filtros: {}
        }
        this.ajaxErrorHandler = (errorTitle)=>{
            return (err)=>{
                if(err.status==500)
                    return this.refs.notificator.error("Error crítico en el servidor", "Contáctese con el departamento de informática.", 4*1000);
                // en otro error, buscar el cuerpo del mensaje
                let msgs = _.values(err.data).join('. ')
                console.log(err)
                console.log(errorTitle, err.data)
                this.refs.notificator.error(errorTitle, msgs, 4*1000);
            }
        }
        this.buscarInventarios = ()=>{
            let mes = this.state.mes
            api.inventario.getRealizadosMesCliente(mes, 12)
                .then(inventarios=>{
                    this.blackbox.reset()
                    inventarios.inventariosFormato.forEach(inventario=>this.blackbox.add(inventario))
                    this.setState( this.blackbox.getListaFiltrada())
                })
        }
        this.onSelectMesChanged = (evt)=>{
            this.setState({
                mes: evt.target.value
            }, ()=>{
                this.buscarInventarios()
            })
        }
    }
    getChildContext(){
        return {
            aprobacionCliente: (idInventario, aprobacionCliente)=>{
                api.inv(idInventario).actualizarAprobacionFCV(aprobacionCliente)
                    .then(inventarioActualizado=> {
                        this.blackbox.actualizarInventario(inventarioActualizado)
                        this.setState(this.blackbox.getListaFiltrada())
                    })
            },
            aprobacionSei: (idInventario, aprobacionSei)=>{
                api.inv(idInventario).actualizarAprobacionSei(aprobacionSei)
                    .then(inventarioActualizado=> {
                        this.blackbox.actualizarInventario(inventarioActualizado)
                        this.setState(this.blackbox.getListaFiltrada())
                    })
            },
            stockCliente: (idInventario, unidadesFCV)=>{
                api.inv(idInventario).actualizarStockFCV(unidadesFCV)
                    .then(inventarioActualizado=>{
                        console.log('inventario actualizado correctamente')
                        this.blackbox.actualizarInventario(inventarioActualizado)
                        this.setState( this.blackbox.getListaFiltrada())
                    })
            },
            observacionCliente:(idInventario, observacionCliente)=>{
                api.inv(idInventario).actualizarObservacion(observacionCliente)
                    .then(inventarioActualizado=>{
                        console.log('inventario actualizado correctamente')
                        this.blackbox.actualizarInventario(inventarioActualizado)
                        this.setState( this.blackbox.getListaFiltrada())
                    })
            },
            actualizarFiltro: (nombreFiltro, filtro)=>{
                this.blackbox.reemplazarFiltro(nombreFiltro, filtro)
                this.setState(this.blackbox.getListaFiltrada())
            },
            correoSEI: ()=>{
                let request = api.facturacion(12).generarCorreoSei(this.state.mes)
                request
                    .then(()=>this.refs.notificator.success("Proceso satisfactorio", "Se ha notificado su aprobación a SEI", 4*1000)
                    )
                    .catch(this.ajaxErrorHandler('Aprobacion inventarios'));
                return request
            },
            generarFacturaTxt: ()=>{
            let request = api.facturacion(12).generarFactura(this.state.mes)
            request
                .then(()=>this.refs.notificator.success("Proceso satisfactorio", "archivo txt de factura generado y enviado correctamente.", 4*1000)
                )
                .catch(this.ajaxErrorHandler('Generar factura'));
            return request
            }
        }
    }
    componentWillMount(){
        this.buscarInventarios()
    }
    render(){
        return (
            <div className={'container-fluid'}>
                <div className={'row'}>
                    <ReactNotify ref='notificator' className={ReactNotifyCSS}/>
                    {/*
                     <div className={'col-sm-2 form-group '}>
                     <label className="control-label" htmlFor="selectCliente">Cliente</label>
                     <select className="form-control"  name="selectCliente"
                     disabled
                     >
                     <option value="0">Todos</option>
                     {this.props.clientes.map((cliente, index)=>{
                     return <option key={index} value={cliente.idCliente}>{`${cliente.nombreCorto} - ${cliente.nombre}`}</option>
                     })}
                     </select>
                     </div>
                    */}
                    <div className={'col-sm-2 form-group '}>
                        <label className="control-label" htmlFor="selectMes">Mes</label>
                        <select className="form-control"  name="selectMes"
                                ref={ref=>this.inputMes=ref}
                                value={this.state.mes}
                                onChange={this.onSelectMesChanged.bind(this)}>
                            >
                            {this.props.meses.map((mes, index)=>{
                                return <option key={index} value={mes['value']}>{`${mes['text']}`}</option>
                            })}
                        </select>
                    </div>
                    {
                        this.props.permisos.aprobarUndCliente?
                            <BotonDetalles
                                mes={this.state.mes}
                            />
                            :
                            <BotonFacturacion
                                mes={this.state.mes}
                            />
                    }
                    <BotonExcel
                        mes={this.state.mes}
                    />
                </div>
                <TablaInventarios
                    permisos = {this.props.permisos}
                    inventarios ={this.state.inventariosFiltrados}
                    filtros={this.state.filtros}
                />
            </div>
        )
    }
}
InventariosFacturacion.propTypes = {
    meses: PropTypes.arrayOf(PropTypes.object),
    // Permisos
    permisos: PropTypes.object.isRequired,
    clientes: PropTypes.array.isRequired
}
InventariosFacturacion.childContextTypes = {
    aprobacionCliente: PropTypes.func,
    aprobacionSei: PropTypes.func,
    stockCliente: PropTypes.func,
    observacionCliente: PropTypes.func,
    actualizarFiltro: PropTypes.func,
    correoSEI: PropTypes.func,
    generarFacturaTxt: PropTypes.func
}
const BotonDetalles = ({mes})=>
    <ModalTrigger>
        {(isVisible, showModal, hideModal)=>
            <button className="btn btn-md btn-primary pull-right" onClick={showModal}>
                {'Detalles'}
                {isVisible && <ModalDetalle
                    hideModal={hideModal}
                    mes={mes}
                />}
            </button>
        }
    </ModalTrigger>
const BotonFacturacion = ({mes})=>
    <ModalTrigger>
        {(isVisible, showModal, hideModal)=>
            <button className="btn btn-md btn-primary pull-right" onClick={showModal}>
                {'Facturar'}
                {isVisible && <ModalFacturacion
                    hideModal={hideModal}
                    mes={mes}
                />}
            </button>
        }
    </ModalTrigger>
const BotonExcel = ({mes})=>
    <a className={'btn btn-md btn-success pull-right'}
       href={`/api/resumen/descargar-excel-mes?mes=${mes}&idCliente=${12}`}>
        Datos Excel
    </a>


// WEBPACK FOOTER //
// ./frontEnd/inventarios/inventarios-facturacion/InventariosFacturacion.jsx